var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customWitdh"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('v-select',{staticClass:"w-full",attrs:{"options":_vm.options,"label":_vm.getLabel(_vm.label),"filterable":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }